import { PageWithLayout } from './_app';
import Main, { makeTitle } from '@/components/layouts/Main';
import Head from 'next/head';
import BoxFull from '@/components/box/BoxFull';

type AboutProps = {};

const About: PageWithLayout<AboutProps> = ({}) => {
  return (
    <>
      <Head>
        <title>{makeTitle('About')}</title>
      </Head>
      <BoxFull type={`happy`} title={`About Porchetta Industries`} mainTitle={`About`}>
        <div className="text-porchetta-white prose">
          <p>
            Most of the Information Security industry relies on Open Source Security tools (both
            Offensive and Defensive) for consultations, trainings and sometimes internal
            capabilities. Yet, if you speak to the developers of these tools, you'll find there is
            little to no support being given back by the same companies that use them.
          </p>

          <p>
            While initiatives such as Github Sponsors and Open Collective have helped, they are
            primarily geared towards the mainstream development community and not the
            Infosec/Hacking community. Additionally they are meant for individuals wanting to
            donate, not companies.
          </p>

          <p>
            Porchetta Industries was founded with the intent to "bridge the gap" between the
            developers of Open Source Security tools and the companies relying on them. We provide a
            centralized way for organizations to directly support all of the developers on our
            platform and in return provide them with exclusive updates, perks and content while at
            the same time continuing to provide a net benefit to the Open Source Information
            Security/Hacking Community at large.
          </p>

          <p>
            How are we doing this exactly? We're approaching this problem from a few different
            angles:
          </p>

          <p>
            Direct monetary support: all profits made through subscriptions are split between
            all of the tool developers on our platform.
          </p>
          <p>
            Transparency: ... it's essential. every 12 months we will publish a full report detailing
            the money we collected and donated to the developers on our platform.
          </p>
          <p>
            Exclusive Updates, Perks & Content for Subscribing Companies: Any organization
            subscribing to Porchetta Industries receives exclusive tool updates, perks and content
            before they are made generally available <span className="text-porchetta-green">❤</span>
            ️ through a timed release.
          </p>
          <p>
            Community Support & Engagement: We want to keep giving back to the Infosec/Hacking
            community, that's always been our number one priority as tool developers and will never
            change. We don't want to make anyone feel left out even though Porchetta Industries is
            primarily meant for companies. Besides publicly releasing any content, tools and updates
            (after a defined time frame) that at first is exclusively given access to our
            subscribers, individuals that submit meaningful Pull Request to the public repositories
            of the tools on our platform (and subsequently get accepted) will receive lifetime
            access to the private updates & content for that tool. We will also be working with our
            subscribers to provide free goodies to the community{' '}
            <span className="text-porchetta-green">❤</span>️
          </p>
        </div>
      </BoxFull>
    </>
  );
};

About.Layout = Main;

export default About;
